import { render } from "./GuideWhite.vue?vue&type=template&id=c87d189c&scoped=true"
import script from "./GuideWhite.vue?vue&type=script&lang=js"
export * from "./GuideWhite.vue?vue&type=script&lang=js"

import "./GuideWhite.vue?vue&type=style&index=0&id=c87d189c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87d189c"]])

export default __exports__